import { Icon } from '../icon'
import { useStyles } from './styles'

export const DailyBonusLocker = ({ lockIconStyles = undefined }: { lockIconStyles?: React.CSSProperties }) => {
  const { classes } = useStyles()

  return (
    <div className={classes.root}>
      <div
        className={classes.lockIcon}
        style={lockIconStyles}
      >
        <Icon view="whiteLock" />
      </div>
    </div>
  )
}
